import ProductCategory from 'pages/Home/ProductCategory'

export default function getTranslationKeyFromCategory(productCategory: ProductCategory) {
  if (productCategory === ProductCategory.Rise) {
    return 'rise'
  }
  if (productCategory === ProductCategory.Storyline) {
    return 'storyline'
  }

  return 'more'
}
